import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

import { AngularFireAuth } from "angularfire2/auth";
import * as firebase from "firebase/app";
import { BackendService } from "./backend.service";
import EmailAuthProvider = firebase.auth.EmailAuthProvider;

@Injectable()
export class AuthService {
  private authState = undefined;
  private authInstance: AngularFireAuth;

  /**
   * @description Represent the authentication service
   * @constructor
   * @param firebaseAuth angular fire authentication
   * @param router angular router from angular core
   */
  constructor(private firebaseAuth: AngularFireAuth, private router: Router) {
    this.firebaseAuth.authState.subscribe(auth => {
      this.authState = auth;
    });
    this.authInstance = this.getAngularFireAuthInstance();
  }

  /**
   * @returns firebase authentication instance
   */
  getAngularFireAuthInstance(): AngularFireAuth {
    return this.firebaseAuth;
  }

  /**
   * @description authState is the firebase authenticated user
   * @returns Observable<firebase.User | null>
   */
  getAuthState(): firebase.User | null {
    return this.authState;
  }

  async getResolvedAuthState(): Promise<any> {
    return new Promise<firebase.User | null>(resolve => {
      this.firebaseAuth.authState.subscribe(user => {
        resolve(user);
      });
    });
  }

  async getCurrentUserId(): Promise<string> {
    const authState = await this.getResolvedAuthState();

    return new Promise<string>(resolve => {
      resolve(BackendService.generateUserId(authState["email"]));
    });
  }

  getIsLoggedIn(): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.firebaseAuth.authState.subscribe(authState => {
        const state = !!authState;
        resolve(state);
      });
    });
  }

  async authenticateNewUser(userEmail): Promise<any> {
    const email = userEmail.toLowerCase();
    const loggedInUserId = await this.getCurrentUserId();
    const emailExists = await this.doesEmailExist(email);
    const resolution = {
      state: true,
      message: BackendService.generateUserId(email)
    };

    return new Promise<any>(resolve => {
      if (!emailExists) {
        this.firebaseAuth.auth
          .createUserWithEmailAndPassword(email, `dummpassword1234${Date.now()}`)
          .then(() => {
            resolve(resolution);
            // Login current user because of Firebase quirks (it logs out the current user when a new user is created)
            this.loginCurrentUser(loggedInUserId).then();
          })
          .catch(err => resolve({ state: false, message: err }));
      } else {
        resolve(resolution);
      }
    });
  }

  private doesEmailExist(email: string): Promise<void> {
    return new Promise(resolve => {
      this.firebaseAuth.auth.fetchSignInMethodsForEmail(email).then(data => {
        resolve(data.length);
      });
    });
  }

  private async loginCurrentUser(userId): Promise<void> {
    const loggedInUserEmail = localStorage.getItem(`${userId}-loopmi-key`);
    const loggedInUserPassword = localStorage.getItem(
      `${userId}-loopmi-secret`
    );
    this.firebaseAuth.auth
      .signInWithEmailAndPassword(loggedInUserEmail, loggedInUserPassword)
      .then();
  }

  updatePassword(currentPassword, newPassword): Promise<boolean> {
    const user = this.firebaseAuth.auth.currentUser;
    const credential = EmailAuthProvider.credential(
      user.email,
      currentPassword
    );

    return user.reauthenticateWithCredential(credential).then(() => {
      return user
        .updatePassword(newPassword)
        .then(() => true)
        .catch(() => false);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth.service.ts